var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", color: "primary" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    directives: [
                      {
                        name: "tap",
                        rawName: "v-tap",
                        value: (e) => _vm.BtnClick(),
                        expression: "(e) => BtnClick()",
                      },
                    ],
                    ref: _vm.reff,
                    class: _vm.myclass,
                    attrs: {
                      color: _vm.icon != "" ? "" : _vm.color,
                      id: _vm.id,
                      disabled: _vm.disabled,
                      fab: _vm.fab,
                      small: _vm.small,
                      icon: _vm.icon != "",
                      large: _vm.large,
                      left: _vm.left,
                      right: _vm.right,
                      up: _vm.up,
                      down: _vm.down,
                    },
                  },
                  on
                ),
                [
                  _vm.icon != ""
                    ? _c(
                        "v-icon",
                        { attrs: { large: _vm.large, color: _vm.color } },
                        [_vm._v(_vm._s(_vm.icon))]
                      )
                    : _c("div", [_vm._v(_vm._s(_vm.lable))]),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      !_vm.notooltip
        ? _c("div", [
            _vm.tooltiplable == ""
              ? _c("span", [_vm._v(_vm._s(_vm.lable))])
              : _vm._e(),
            !_vm.tooltiplable == ""
              ? _c("span", [_vm._v(_vm._s(_vm.tooltiplable))])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }